// Funções utilitárias para o projeto

export function createPageUrl(pageName) {
  // Simula a criação de URLs para as páginas
  const routes = {
    "Dashboard": "/",
    "Upload": "/upload",
    "UploadedFiles": "/files",
    "ApiTester": "/api-tester",
    "Operations": "/operations",
    "GoogleSheetsQuestor": "/google-sheets-questor",
    "AnnualRevenue": "/annual-revenue",
    "UpdateAnnualRevenue": "/update-annual-revenue",
    "VariavelRevenue": "/variavel-revenue",
    "BensEmpresa": "/bens-empresa",
    "BensVeiculos": "/bens-veiculos",
    "AgentIrpf": "/agent-irpf",
    "AgentRendPF": "/agent-rendpf",
    "AgentQuestor": "/agent-questor",
    "RendimentoPessoaFisica": "/rendimento-pessoa-fisica",
    "ProLabore": "/pro-labore",
    "Extrato": "/extrato",
    "CreditCard": "/credit-card",
    "ContaReceitaZendry": "/conta-receita-zendry",
    "DespesasGeralZendry": "/despesas-geral-zendry",
    "ContasaPagarZendry": "/contas-a-pagar-zendry",
    "C6Bank": "/c6-bank",
    "TovSolucoes": "/tov-solucoes",
    "Fibank": "/fibank",
    "FibankRJX": "/fibank-rjx",
    "BancoDoBrasil": "/banco-do-brasil",
    "BancoDoBrasilRJX": "/banco-do-brasil-rjx",
    "ControlePonto": "/controle-ponto",
    "SoftBradesco": "/soft-bradesco",
    "SoftSantander": "/soft-santander",
    "SoftUnicred": "/soft-unicred"
  };
  
  return routes[pageName] || "/";
}

// Função para combinar classes CSS condicionalmente
export function cn(...args) {
  return args.filter(Boolean).join(' ');
}
